import Repository from './Repository';

export default {
    submit(data) {
        return Repository.post('/contact', data);
    }
}